import { render, staticRenderFns } from "./address_edit_dialog.vue?vue&type=template&id=ccb23eb0&scoped=true"
import script from "./address_edit_dialog.vue?vue&type=script&lang=js"
export * from "./address_edit_dialog.vue?vue&type=script&lang=js"
import style0 from "./address_edit_dialog.vue?vue&type=style&index=0&id=ccb23eb0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb23eb0",
  null
  
)

export default component.exports